import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {YearService} from '../../services/year.service';
import {Year} from '../../interface/Year';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-school-current-year',
  templateUrl: './current-year.component.html',
  styleUrls: ['./current-year.component.scss']
})
export class CurrentYearComponent implements OnInit {

  public years!: Year[];
  temp = [];
  selected = [];
  public closeResult: string;
  public getDismissReason: string;
  public isButtonVisible = false;

  rows = [];
  loadingIndicator = true;
  reorderable = true;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(public yearService: YearService, config: NgbModalConfig, public router: Router, private translate: TranslateService,
              private toast: ToastrService) {
    this.getYearList();

    config.backdrop = 'static';
    config.keyboard = false;
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {

  }

  getYearList(): any {
    this.yearService.getCollection().subscribe({
      next: (res: any) => {
        this.years = res['hydra:member'];

        console.log(this.years);

        // cache our list
        this.temp = [...res['hydra:member']];

        this.rows = this.years;

        this.loadingIndicator = false;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        console.log('Error while fetching the records');
        this.loadingIndicator = false;
      }
    });
  }

  // tslint:disable-next-line:typedef
  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    // tslint:disable-next-line:only-arrow-functions typedef
    const temp = this.temp.filter(function(d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  onSelect({selected}): void{
    console.log('Select Event', selected, this.selected);
    console.log(this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    this.isButtonVisible = this.selected.length > 0;

  }

  onActivate(event): void {
    console.log('Activate Event', event);
  }

  remove(): void {
    this.selected = [];
  }

  toggleExpandRow(row): void {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event): void {
    console.log('Detail Toggled', event);
  }

  setUserCurrentYear(id: number): any {
    Swal.fire({
      title: this.translate.instant('are you sure?'),
      text: this.translate.instant('you will be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, set it current!'),
    }).then((result: any): void => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;
        this.yearService.setUserCurrentYear(id).subscribe({
          next: (res: any): void => {
            console.log(res);
            const userLocal = JSON.parse(localStorage.getItem('user'));
            userLocal.currentYear = res;
            localStorage.setItem('user', JSON.stringify(userLocal));

            this.toast.success(this.translate.instant('your current year') + ' ' + this.translate.instant('seteed') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getYearList();

          },
          error: (res) => {
            this.loadingIndicator = false;
            this.toast.error(res['hydra:title'], 'Error');
          }
        });
      }
    });

  }

  
}
